import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CALCULATORS, PAGE_BANNERS, heroStyle } from "../data/site";

// Shared layout wrapper for every calculator page.
function CalcShell({ meta, children, note }) {
  const others = CALCULATORS.filter((c) => c.slug !== meta.slug).slice(0, 5);

  return (
    <>
      <section className="fi-hero" style={{ padding: "6rem 0 2.5rem", ...heroStyle(PAGE_BANNERS.calculators) }}>
        <Container>
          {/* <Link to="/calculators" className="text-white-50">
            ← All Calculators
          </Link> */}
          <h1 className="mt-2 mb-1">
            {meta.title}
          </h1>
          <p className="lead mb-0">{meta.desc}</p>
        </Container>
      </section>

      <Container className="py-5">
        <Row className="g-4">
          <Col lg={8}>
            <Card className="fi-card">
              <Card.Body className="p-4">{children}</Card.Body>
            </Card>
          </Col>

          <Col lg={4}>
            <Card className="fi-card">
              <Card.Body>
                <h5 className="fw-bold mb-3">Other Calculators</h5>
                {others.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/calculators/${c.slug}`}
                    className="d-flex align-items-center gap-2 py-2 text-reset"
                    style={{ borderBottom: "1px solid #eee" }}
                  >
                    <span>{c.emoji}</span>
                    <span className="fw-semibold">{c.title}</span>
                  </Link>
                ))}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {note && (
          <div
            className="fi-stat p-4 text-start mt-4 mb-2"
            style={{ background: "rgba(11,110,79,0.07)" }}
          >
            {note}
          </div>
        )}
      </Container>
    </>
  );
}

export default CalcShell;
